import {useEffect, useRef, useState} from 'react'


import '../assets/css/sobre.css'
import LateralMenu from './LateralMenu';
import BoxComp from './BoxComp.jsx';

import saopedroCour1 from '../assets/imgs/saopedroCour1.jpeg';
import saopedroCour2 from '../assets/imgs/saopedroCour2.jpeg';
import saopedroCour3 from '../assets/imgs/saopedroCour3.jpeg';
import saopedroCour4 from '../assets/imgs/saopedroCour4.jpeg';
import saopedroCour5 from '../assets/imgs/saopedroCour5.jpeg';


// var width_ = window.innerWidth;
// var height_ = window.innerHeight;

export const Sobre = ({ativaResp}) => {

    const [sliderController, setSlideController] = useState(1)
    const imagesArr = [saopedroCour1,saopedroCour2,saopedroCour3,saopedroCour4,saopedroCour5]
    const imagesCountMax = 5
    const lateralMenu = useRef()

    return <>
        <LateralMenu ativaResp={ativaResp} ref={lateralMenu}/>
        <div className="containerPrincipal sobreComunidade" style={{maxHeight: "100vh"}}>
        <BoxComp lateralMenu={lateralMenu}/>
        <div className="containerSobre">
            <div className="titlePage">Sobre a comunidade</div>


            <div className="conteudoSobre">

                <div className="leftContainer">
                    <div className="imageSlider" style={{'--imageSaoPedro': `url('${imagesArr[sliderController]}')`}}></div>
                    <div className="buttonsSlider">
                        <div className="counter">
                            {Array.from({ length: imagesCountMax }, (_, index) => {
                                return <div className="dotProx" style={ index === sliderController ? {width: '25px', borderRadius: '5px'} : {}}></div>
                            })}
                        </div>
                        <div className="selectSeq">
                            <div className="anterior" onClick={()=>{
                                const sliderVal = sliderController-1
                                if(sliderVal <= 0){
                                    setSlideController(0)
                                }else{
                                    setSlideController(sliderVal)
                                }
                                }}></div>
                            <div className="proxima" onClick={()=>{
                                const sliderVal = sliderController+1
                                if(sliderVal >= imagesCountMax){
                                    setSlideController(0)
                                }else{
                                    setSlideController(sliderVal)
                                }
                                }}></div>
                        </div>
                    </div>

                </div>

                <div className="divider"></div>

                <div className={`rightContainer ${ativaResp ? '' : 'scrollbar'}`}>
                Localizada em Belo Horizonte na Rua Maria Amélia Pimenta 151 Diamante - Texeira Dias,  a comunidade é responsável por integrar e estabelecer um centro de apoio, união e conforto entre todos aqueles que moram dentro e nas imediações do bairro Texeira dias, além de receber com alegria os visitantes de diferentes regiões.
                    <br />
                    Fundado em 1978 com o auxílio de tantos irmão e irmãs que desejavam construir  uma Comunidade que servisse de amparo para os recém moradores da região dos bairros Diamante e Teixeira Dias, mas que sobretudo atendesse as necessidades espirituais do seu povo. 
                    <br />
                    Esta apresentação não é apenas um pequeno resumo, mas também um convite para conhecer  melhor nossa comunidade e desfrutar de diversos momentos, contamos com sua presença e a de quem você quiser convidar
                    <br />
                    Por fim, aqui vai uma passagem de reflexão.
                    Salmo 27:14 : “Espera no Senhor, anima-te, e ele fortalecerá o teu coração; espera, pois no Senhor.”
                </div>

            </div>

        </div>
''
        </div>
    </>
}

export default Sobre;